<app-header-page>
    <h1>{{ 'HEADERS.GARANT' | translate }}</h1>
</app-header-page>

<app-component-folder-and-file-table
        (eventClick)="onEventTrClick($event)"
        (eventFind)="onEventFind($event)"
        [$mediator]="controller.$mediator"
>
</app-component-folder-and-file-table>
